// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2bRCk","row":"Node_row__ODMXX","label":"Node_label__-aoJo","footer":"Node_footer__GlMYf"};